<template>
    <div v-if="participants" class="grid-item" v-tooltip:grey="participants">{{ text }}</div>
    <div v-else class="grid-item">{{ text }}</div>
</template>
<script src="./PitGridItem.ts"></script>
